import React from "react";
import RightSectionEM from "../educationMamaComponents/RightSectionEM/RightSectionEM";
import Logo from "../../../src/public/images/logo.png";
import HeaderComponent from "./HeaderComponent";
import "./invoiceDesign.scss";
import moment from "moment";

const InvoiceDesign = ({ invoiceDetails }) => {
  console.log("invoiceDetails", invoiceDetails);
  return (
    <div className="FeedComponent FeedComponentForTeacher">
      <div style={{ padding: "2vh 0" }}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="">
                <div className="row">
                  {/* <div className="col-md-12 p-3" style={{ background: "#004AAD" }}>
                    <div className="d-flex justify-content-between">
                      <img src={Logo} />
                      <h3 className="text-light my-auto">INVOICE</h3>
                    </div>
                  </div> */}
                  <div>
                    <div className="row smallLabelForMobile">
                      <div className="col-md-12 text-right mt-4">
                        <label>Invoice No : {invoiceDetails?.id}</label> <br />
                        <label>
                          Invoice Date : {moment(invoiceDetails?.ts).format("Do MMMM YYYY")}
                        </label>{" "}
                        <br />
                      </div>
                      <div className="col-md-12">
                        <div className="d-flex justify-content-between">
                          <div style={{ color: "#004AAD" }}>
                            <h3>{invoiceDetails?.candidate_nu_users?.user_name}</h3>
                          </div>
                          <div className="text-right">
                            <label>
                              Due Date : {moment(invoiceDetails?.due_date).format("Do MMMM YYYY")}
                            </label>{" "}
                            <br />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <table className="table">
                          <thead>
                            <tr className="tableForInvoice">
                              <th scope="col">COURSES</th>
                              {/* <th scope="col">PERIOD</th> */}
                              <th className="text-center" scope="col">
                                LATE FEE
                              </th>
                              <th className="text-center" scope="col">
                                TOTAL
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <label className="boldLabel">
                                  {invoiceDetails?.lm_course?.course_name}
                                </label>
                                <br />
                                {invoiceDetails?.lm_course_coupon && (
                                  <label className="text-muted" style={{ fontSize: 12 }}>
                                    Used {invoiceDetails?.lm_course_coupon?.coupon_code}&nbsp;
                                    Coupon Code
                                  </label>
                                )}
                              </td>
                              {/* <td>
                                <label className="boldLabel">Jan-Feb</label>
                              </td> */}
                              <td className="text-center">
                                <label className="text-muted" style={{ fontSize: 12 }}>
                                  None if paid by{" "}
                                  {moment(invoiceDetails?.due_date).format("Do MMM YY")}
                                </label>
                              </td>
                              <td className="text-center">
                                <label className="boldLabel">
                                  PKR {invoiceDetails?.amount_payable ? Number(invoiceDetails?.amount_payable).toLocaleString(): 0}
                                </label>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div className="col-md-12 singleLine"></div>
                      </div>
                      <div className="col-md-8"></div>
                      <div className="col-md-4 mt-5">
                        <div className="d-flex justify-content-between">
                          <label className="boldLabel">Sub Total : </label>
                          <label className="boldLabel">PKR {invoiceDetails?.amount_payable ? Number(invoiceDetails?.amount_payable).toLocaleString() : 0}</label>
                        </div>
                        <div className="d-flex justify-content-between">
                          <label className="boldLabel">Tax : </label>
                          <label className="boldLabel">PKR 0</label>
                        </div>
                      </div>
                      <div className="col-md-8"></div>
                      <div className="col-md-4 singleLine mt-3"></div>
                      <div className="col-md-8"></div>
                      <div className="col-md-4">
                        <div className="d-flex justify-content-between mt-2">
                          <label className="boldLabel">Total : </label>
                          <label className="boldLabel">PKR {invoiceDetails?.amount_payable ? Number(invoiceDetails?.amount_payable).toLocaleString() : 0}</label>
                        </div>
                      </div>
                      <div className="col-md-8"></div>
                      {/* <div className="col-md-4">
                        <button className="btn btn-success btn btn-block mt-4 font-weight-bold">
                          PAY NOW
                        </button>
                      </div> */}
                    </div>
                  </div>

                  <div className="col-md-12 p-3" style={{ background: "#E9EFF8" }}>
                    <h5 style={{ color: "#004AAD" }}>Terms & Conditions</h5>
                    <p style={{ color: "#004AAD" }}>
                      The monthly fee is non-refundable even if the student discontinues before
                      completing the month All fees should be paid before the due date to avoid late
                      fees of Rs. 750 per course
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceDesign;
